export const stripTypename = <T extends Record<string, any>>(obj: T): Omit<T, '__typename'> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { __typename: _, ...rest } = obj;
  return rest;
};
